import { VehicleAmenityAlert } from '@/models/dto/Vehicle'
import {
  loadFromSession,
  removeFromSession,
  saveToSession,
} from '@/utils/sessionStorage'

const VEHICLE_AMENITY_ALERTS_KEY = 'vehicleAmenityAlerts'

export function saveVehicleAmenityAlerts(
  alerts: VehicleAmenityAlert[]
): void {
  saveToSession(VEHICLE_AMENITY_ALERTS_KEY, alerts)
}

export function loadVehicleAmenityAlerts(): VehicleAmenityAlert[] {
  return loadFromSession<VehicleAmenityAlert[]>(VEHICLE_AMENITY_ALERTS_KEY) ?? []
}

export function clearVehicleAmenityAlerts(): void {
  removeFromSession(VEHICLE_AMENITY_ALERTS_KEY)
}

/**
 * Appends newly fetched alerts to the existing pending queue.
 */
export function mergeAmenityAlerts(
  pending: VehicleAmenityAlert[],
  fetched: VehicleAmenityAlert[]
): VehicleAmenityAlert[] {
  return [...pending, ...fetched]
}
